<div class="container-fluid h-100 d-flex flex-column">

  <!-- Action Bar -->
  <div class="row">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <div>
        @if(hasSelectedErrors()) {
          <app-lt-button 
            (click)="openBulkUpdateDialog()" 
            classes="lt-orange"
            [label]="`Update ${selectedErrorCount()} Selected Error${selectedErrorCount() === 1 ? '' : 's'}`"
            appearance="elevated"
            ></app-lt-button>
        }
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="errors-grid-container">
      @if(errorsGrid() && errorsGridReady() === true) {
        <app-lt-png-table #table
          [showToolbarInput]="true"
          [gridSettingsInput]="errorsGrid()"
          (selectionChange)="handleSelectionChange($event)">
      
          <!-- Server ID Header Template -->
          <ng-template appGridTemplate="serverIdHeader" let-column="column">
              <i class="bi bi-server" matTooltip="Server"></i>
          </ng-template>

          <ng-template appGridTemplate="statusName" let-rowData let-column="column" let-value="value" let-rowIndex="rowIndex">
            <div class="d-inline justify-content-center">
              <app-lt-current-status-toggle
                  [value]="value ?? null"
                  [disabled]="statusUpdating() || !(rowData && selectedError()?.integrationErrorId !== rowData.integrationErrorId)"
                  (statusChange)="triggerUpdateStatusMessage(rowData, $event)"
              ></app-lt-current-status-toggle>
              
            </div>
          </ng-template>

          <ng-template appGridTemplate="statusNameFilter" let-column="column">
              <div class="p-2">
                <app-lt-current-status-toggle
                    [value]="filterValue"
                    (statusChange)="onColumnStatusFilter($event, column.field)"
                ></app-lt-current-status-toggle>
                @if(hasStatusFilter()) {
                  <div class="mt-1 text-center">
                    <button matIconButton (click)="clearFilters()" aria-label="Clear Status Filter" >
                      <mat-icon>filter_alt_off</mat-icon>
                    </button>
                  </div>
                }
              </div>

          </ng-template>

          <ng-template appGridTemplate="criticalError" let-rowData let-column="column" let-value="value" let-rowIndex="rowIndex">
              <div class="text-center">
                @if(rowData && (rowData.criticalError === true || rowData.actionNeeded === true) && rowData.statusName !== 'Resolved') {
                  <i class="bi bi-x-circle-fill critical-error-icon" 
                    matTooltip="Critical Error - Action Needed"></i>
                }
              </div>
          </ng-template>

          <!-- Integration Name Cell Template (with navigation) -->
          <ng-template appGridTemplate="integrationName" let-rowData let-column="column" let-value="value">
            <div class="text-wrap">
              <a [routerLink]="['/editConfigV2', rowData.clientInformationId, rowData.integrationId]" 
                 target="_blank"
                 class="text-decoration-none">
                {{ value }}
              </a>
            </div>
          </ng-template>

          <ng-template appGridTemplate="expandedrow" let-rowData let-rowIndex="rowIndex">
            @if(rowData && rowData.integrationErrorId){
                <div class="p-3 bg-light border-start border-primary border-3">
                  <app-lt-error-detail-view
                    [errorData]="rowData"
                    (errorUpdated)="handleErrorUpdated($event)"
                  ></app-lt-error-detail-view>
                </div>
              } @else {
                <div class="p-3 text-muted text-center">
                  <i class="bi bi-exclamation-triangle"></i>
                  No detail data available
                </div>
              }
          </ng-template>

        </app-lt-png-table>
      } @else {
        <div class="loading-display d-flex justify-content-center align-items-center">
          <app-lt-spinner></app-lt-spinner>
        </div>
      } 
    </div>
  </div>
  
</div>